<div>
  <header class="header-layout">
    <div class="logo-container">
      <img src="../../../assets/icone/sfa-icon-doove-golden 1.svg" alt="Logo" class="logo-titulo">
    </div>
    <h1>Olá, {{usuario.nome}}!</h1>
  </header>
  <main class="main-layout">
    <section class="left-section">
      <div class="top-box">
        <h2>Seja bem-vindo ao portal Parceiros</h2>
        <p>Aqui você encontra, de forma simples e segura, todos os documentos relacionados às suas parcerias conosco.
          Pensamos neste espaço para facilitar o acesso às informações importantes, dar mais autonomia no dia a dia e
          fortalecer nossa relação. Utilize o botão abaixo para consultar os documentos sempre que precisar.
        </p>
        <button class="btn-secondary" (click)="redirecionarMeusDocumentos()">Começar agora</button>
        <img src="../../../assets/icone/formas.svg" alt="Padrão decorativo" class="top-box-pattern">
      </div>
      <div class="three-boxes">
        <div class="box" (click)="redirecionarMeusDocumentos()">
          <p>Meus Documentos</p>
          <img src="../../../assets/icone/meus-documentos.svg" alt="Padrão decorativo" class="box-pattern">
        </div>
        <div class="box" (click)="redirecionarPerfil()">
          <p>Meu Perfil</p>
          <img src="../../../assets/icone/meu-perfil.svg" alt="Padrão decorativo" class="box-pattern">
        </div>
        <div class="box" (click)="abrirModalLog()">
          <p>Logs</p>
          <img src="../../../assets/icone/logs.svg" alt="Padrão decorativo" class="box-pattern">
        </div>
      </div>
    </section>
    <section class="right-section">
      <app-documento [documento]="documento"></app-documento>
    </section>
  </main>
</div>
